import {
  KITS_BYPATIENT_GET_LIST,
  KITS_BYPATIENT_GET_LIST_SUCCESS,
  KITS_BYPATIENT_GET_LIST_ERROR,
  KITS_USER_GET_LIST,
  KITS_USER_GET_LIST_SUCCESS,
  KITS_USER_GET_LIST_ERROR,
  KITS_BYDOCTOR_GET_LIST,
  KITS_BYDOCTOR_GET_LIST_SUCCESS,
  KITS_BYDOCTOR_GET_LIST_ERROR,
  KIT_GET_INFO,
  KIT_GET_INFO_SUCCESS,
  KIT_GET_INFO_ERROR,
  KIT_ADD_ITEM,
  KIT_ADD_ITEM_SUCCESS,
  KIT_ADD_ITEM_ERROR,
  KIT_EDIT_ITEM,
  KIT_EDIT_ITEM_SUCCESS,
  KIT_EDIT_ITEM_ERROR,
  KIT_UNLOCK_PLUGIN_ITEM,
  KIT_UNLOCK_PLUGIN_ITEM_SUCCESS,
  KIT_UNLOCK_PLUGIN_ITEM_ERROR,
  KIT_ACTIVATE_ITEM,
  KIT_ACTIVATE_ITEM_SUCCESS,
  KIT_ACTIVATE_ITEM_ERROR,
  KIT_GET_RESULTS,
  KIT_GET_RESULTS_SUCCESS,
  KIT_GET_RESULTS_ERROR,
  KIT_GET_RESULTS_BEHAVIOUR,
  KIT_GET_RESULTS_BEHAVIOUR_SUCCESS,
  KIT_GET_RESULTS_BEHAVIOUR_ERROR,
  KIT_GET_RESULTS_BIOMARKERS,
  KIT_GET_RESULTS_BIOMARKERS_SUCCESS,
  KIT_GET_RESULTS_BIOMARKERS_ERROR,
  KITS_GET_RESULTS_TIMECOURSE,
  KITS_GET_RESULTS_TIMECOURSE_SUCCESS,
  KITS_GET_RESULTS_TIMECOURSE_ERROR,
  KIT_REMOVE_ITEM,
  KIT_REMOVE_ITEM_SUCCESS,
  KIT_REMOVE_ITEM_ERROR,
  KIT_GET_UPLOADED_DATA,
  KIT_GET_UPLOADED_DATA_SUCCESS,
  KIT_GET_UPLOADED_DATA_ERROR,
  KIT_REMOVE_UPLOADED_DATA,
  KIT_REMOVE_UPLOADED_DATA_SUCCESS,
  KIT_REMOVE_UPLOADED_DATA_ERROR,
  KIT_TAKEACTION_EDIT_ITEM,
  KIT_TAKEACTION_EDIT_ITEM_SUCCESS,
  KIT_TAKEACTION_EDIT_ITEM_ERROR,
  KIT_RESULTS_COMMENTS_EDIT_ITEM,
  KIT_RESULTS_COMMENTS_EDIT_ITEM_SUCCESS,
  KIT_RESULTS_COMMENTS_EDIT_ITEM_ERROR,
  KIT_TAKEACTION_REMOVE_ITEM,
  KIT_TAKEACTION_REMOVE_ITEM_SUCCESS,
  KIT_TAKEACTION_REMOVE_ITEM_ERROR,
  KIT_REPORT_GET_LOGO,
  KIT_REPORT_GET_LOGO_SUCCESS,
  KIT_REPORT_GET_LOGO_ERROR,
  KIT_REPORT_EDIT_LOGO,
  KIT_REPORT_EDIT_LOGO_SUCCESS,
  KIT_REPORT_EDIT_LOGO_ERROR,
  KIT_CLEAR_DATA,
  KITS_BYPATIENT_LIST_CLEAR_DATA,
  KITS_RESULTS_CLEAR_DATA,
  KITS_RESULTS_TIMECOURSE_CLEAR_DATA,
} from "../actions";

//* LIST OF THE KITS PER PATIENT // ---------------------------------------------------------------------------------------------
export const getKitsPerPatientList = (payload) => {
  //console.log(payload);

  return {
    type: KITS_BYPATIENT_GET_LIST,
    payload: payload,
  };
};

export const getKitsPerPatientListSuccess = (items) => {
  //console.log(items);
  return { type: KITS_BYPATIENT_GET_LIST_SUCCESS, payload: items };
};

export const getKitsPerPatientListError = (error) => ({
  type: KITS_BYPATIENT_GET_LIST_ERROR,
  payload: error,
});

//* LIST OF THE KITS PER USER // ---------------------------------------------------------------------------------------------
export const getKitsPerUserList = (payload) => {
  //console.log(payload);

  return {
    type: KITS_USER_GET_LIST,
    payload: payload,
  };
};

export const getKitsPerUserListSuccess = (items) => {
  //console.log(items);
  return { type: KITS_USER_GET_LIST_SUCCESS, payload: items };
};

export const getKitsPerUserListError = (error) => ({
  type: KITS_USER_GET_LIST_ERROR,
  payload: error,
});

//* LIST OF THE KITS PER DOCTOR // ---------------------------------------------------------------------------------------------
export const getKitsByDoctorList = (payload) => {
  //console.log(payload);

  return {
    type: KITS_BYDOCTOR_GET_LIST,
    payload: payload,
  };
};

export const getKitsByDoctorListSuccess = (items) => {
  //console.log(items);
  return { type: KITS_BYDOCTOR_GET_LIST_SUCCESS, payload: items };
};

export const getKitsByDoctorListError = (error) => ({
  type: KITS_BYDOCTOR_GET_LIST_ERROR,
  payload: error,
});

//* INFO OF THE KIT PER experimentID // ---------------------------------------------------------------------------------------------
export const getKitInfo = (payload) => {
  //console.log(payload);

  return {
    type: KIT_GET_INFO,
    payload: payload,
  };
};

export const getKitInfoSuccess = (items) => {
  //console.log(items);
  return { type: KIT_GET_INFO_SUCCESS, payload: items };
};

export const getKitInfoError = (error) => ({
  type: KIT_GET_INFO_ERROR,
  payload: error,
});

//* ADD KIT // ---------------------------------------------------------------------------------------------
export const addKitItem = (item) => {
  //console.log(item);

  return { type: KIT_ADD_ITEM, payload: item };
};

export const addKitItemSuccess = (items) => {
  //console.log(items);

  return {
    type: KIT_ADD_ITEM_SUCCESS,
    payload: items,
  };
};

export const addKitItemError = (error) => ({
  type: KIT_ADD_ITEM_ERROR,
  payload: error,
});

//* EDIT KIT // ---------------------------------------------------------------------------------------------
export const editKitItem = (item) => {
  console.log(item);
  return { type: KIT_EDIT_ITEM, payload: item };
};

export const editKitItemSuccess = (items) => {
  console.log(items);
  return {
    type: KIT_EDIT_ITEM_SUCCESS,
    payload: items,
  };
};

export const editKitItemError = (error) => ({
  type: KIT_EDIT_ITEM_ERROR,
  payload: error,
});

//* UNLOCK PLUGIN // ---------------------------------------------------------------------------------------------
export const unlockPluginItem = (item) => {
  console.log(item);
  return { type: KIT_UNLOCK_PLUGIN_ITEM, payload: item };
};

export const unlockPluginItemSuccess = (items) => {
  console.log(items);
  return {
    type: KIT_UNLOCK_PLUGIN_ITEM_SUCCESS,
    payload: items,
  };
};

export const unlockPluginItemError = (error) => ({
  type: KIT_UNLOCK_PLUGIN_ITEM_ERROR,
  payload: error,
});

//* ACTIVATED KIT // ---------------------------------------------------------------------------------------------
export const activateKitItem = (item) => {
  //console.log(item);
  return { type: KIT_ACTIVATE_ITEM, payload: item };
};

export const activateKitItemSuccess = (items) => {
  //console.log(items);
  return {
    type: KIT_ACTIVATE_ITEM_SUCCESS,
    payload: items,
  };
};

export const activateKitItemError = (error) => ({
  type: KIT_ACTIVATE_ITEM_ERROR,
  payload: error,
});

//* RESULTS OF THE KIT PER experimentID // ---------------------------------------------------------------------------------------------
export const getKitResults = (payload) => {
  //console.log(payload);

  return {
    type: KIT_GET_RESULTS,
    payload: payload,
  };
};

export const getKitResultsSuccess = (items) => {
  //console.log(items);
  return { type: KIT_GET_RESULTS_SUCCESS, payload: items };
};

export const getKitResultsError = (error) => ({
  type: KIT_GET_RESULTS_ERROR,
  payload: error,
});

//* BEHAVIOUR for RESULTS OF THE KIT  // ---------------------------------------------------------------------------------------------
export const getKitResultsBehaviour = (payload) => {
  //? I don't need the payload

  return {
    type: KIT_GET_RESULTS_BEHAVIOUR,
    payload: payload,
  };
};

export const getKitResultsBehaviourSuccess = (items) => {
  return { type: KIT_GET_RESULTS_BEHAVIOUR_SUCCESS, payload: items };
};

export const getKitResultsBehaviourError = (error) => ({
  type: KIT_GET_RESULTS_BEHAVIOUR_ERROR,
  payload: error,
});

//* BIOMARKERS for RESULTS OF THE KIT  // ---------------------------------------------------------------------------------------------
export const getKitResultsBiomarkers = (payload) => {
  //? I don't need the payload

  return {
    type: KIT_GET_RESULTS_BIOMARKERS,
    payload: payload,
  };
};

export const getKitResultsBiomarkersSuccess = (items) => {
  return { type: KIT_GET_RESULTS_BIOMARKERS_SUCCESS, payload: items };
};

export const getKitResultsBiomarkersError = (error) => ({
  type: KIT_GET_RESULTS_BIOMARKERS_ERROR,
  payload: error,
});

//* TIMECOURSE for RESULTS OF THE KITS  // ---------------------------------------------------------------------------------------------
export const getKitsResultsTimecourse = (items, target) => {
  console.log(items, target);

  return {
    type: KITS_GET_RESULTS_TIMECOURSE,
    payload: { items, target },
  };
};

export const getKitsResultsTimecourseSuccess = (payload) => {
  console.log(payload);
  return { type: KITS_GET_RESULTS_TIMECOURSE_SUCCESS, payload: payload };
};

export const getKitsResultsTimecourseError = (error) => ({
  type: KITS_GET_RESULTS_TIMECOURSE_ERROR,
  payload: error,
});

//* REMOVE KIT // ---------------------------------------------------------------------------------------------
export const removeKitItem = (item) => ({
  type: KIT_REMOVE_ITEM,
  payload: item,
});

export const removeKitItemSuccess = (items) => {
  console.log("removeKitItemSuccess", items);

  return {
    type: KIT_REMOVE_ITEM_SUCCESS,
    payload: items,
  };
};

export const removeKitItemError = (error) => {
  console.log(error);
  return {
    type: KIT_REMOVE_ITEM_ERROR,
    payload: error,
  };
};

//* UPLOADED DATA OF THE KIT PER experimentID // ---------------------------------------------------------------------------------------------
export const getKitUploadedData = (payload) => {
  // console.log(payload);

  return {
    type: KIT_GET_UPLOADED_DATA,
    payload: payload,
  };
};

export const getKitUploadedDataSuccess = (items) => {
  //console.log(items);
  return { type: KIT_GET_UPLOADED_DATA_SUCCESS, payload: items };
};

export const getKitUploadedDataError = (error) => ({
  type: KIT_GET_UPLOADED_DATA_ERROR,
  payload: error,
});

//* REMOVE ALL UPLOADED DATA OF THE KIT PER experimentID // ---------------------------------------------------------------------------------------------
export const removeKitUploadedData = (payload) => {
  console.log(payload);

  return {
    type: KIT_REMOVE_UPLOADED_DATA,
    payload: payload,
  };
};

export const removeKitUploadedDataSuccess = (items) => {
  //console.log(items);
  return { type: KIT_REMOVE_UPLOADED_DATA_SUCCESS, payload: items };
};

export const removeKitUploadedDataError = (error) => ({
  type: KIT_REMOVE_UPLOADED_DATA_ERROR,
  payload: error,
});

//* EDIT KIT RESULTS TAKE ACTION // ---------------------------------------------------------------------------------------------
export const editKitResultsTakeActionItem = (item) => {
  //console.log(item);
  return { type: KIT_TAKEACTION_EDIT_ITEM, payload: item };
};

export const editKitResultsTakeActionItemSuccess = (items) => {
  //console.log(items);
  return {
    type: KIT_TAKEACTION_EDIT_ITEM_SUCCESS,
    payload: items,
  };
};

export const editKitResultsTakeActionItemError = (error) => ({
  type: KIT_TAKEACTION_EDIT_ITEM_ERROR,
  payload: error,
});

//* REMOVE KIT RESULTS EDITED TAKE ACTION  // ---------------------------------------------------------------------------------------------
export const removeKitResultsTakeActionItem = (item) => {
  //console.log(item);
  return { type: KIT_TAKEACTION_REMOVE_ITEM, payload: item };
};

export const removeKitResultsTakeActionItemSuccess = (items) => {
  //console.log(items);
  return {
    type: KIT_TAKEACTION_REMOVE_ITEM_SUCCESS,
    payload: items,
  };
};

export const removeKitResultsTakeActionItemError = (error) => ({
  type: KIT_TAKEACTION_REMOVE_ITEM_ERROR,
  payload: error,
});

//* EDIT KIT COMMENTS RESULTS  // ---------------------------------------------------------------------------------------------
export const editKitResultsCommentsItem = (item) => {
  //console.log(item);
  return { type: KIT_RESULTS_COMMENTS_EDIT_ITEM, payload: item };
};

export const editKitResultsCommentsItemSuccess = (items) => {
  //console.log(items);
  return {
    type: KIT_RESULTS_COMMENTS_EDIT_ITEM_SUCCESS,
    payload: items,
  };
};

export const editKitResultsCommentsItemError = (error) => ({
  type: KIT_RESULTS_COMMENTS_EDIT_ITEM_ERROR,
  payload: error,
});

//* GET REPORT LOGO  ---------------------------------------------------------------------------
export const getReportLogo = (item) => {
  console.log("inside get logo action");
  return {
    type: KIT_REPORT_GET_LOGO,
    payload: item,
  };
};

export const getReportLogoSuccess = (items) => {
  // console.log(items);

  return {
    type: KIT_REPORT_GET_LOGO_SUCCESS,
    payload: items,
  };
};

export const getReportLogoError = (error) => {
  // console.log(error);
  return {
    type: KIT_REPORT_GET_LOGO_ERROR,
    payload: error,
  };
};

//* EDIT REPORT LOGO -----------------------------------------------------------------------------
export const editReportLogoItem = (item) => {
  // console.log("inside avatar action");
  return {
    type: KIT_REPORT_EDIT_LOGO,
    payload: item,
  };
};

export const editReportLogoItemSuccess = (items) => {
  // console.log(items);

  return {
    type: KIT_REPORT_EDIT_LOGO_SUCCESS,
    payload: items,
  };
};

export const editReportLogoItemError = (error) => {
  // console.log(error);
  return {
    type: KIT_REPORT_EDIT_LOGO_ERROR,
    payload: error,
  };
};

//* CLEAR KIT  DATA// ---------------------------------------------------------------------------------------------
// clearing redux state at logout
export const clearKitData = (history) => {
  return {
    type: KIT_CLEAR_DATA,
    payload: { history },
  };
};

//* CLEAR KITS LIST DATA of the PATIENT // ---------------------------------------------------------------------------------------------
// clearing redux state when unmounting patient profile page
export const clearKitsPatientListData = (history) => {
  return {
    type: KITS_BYPATIENT_LIST_CLEAR_DATA,
    payload: { history },
  };
};

//* CLEAR KIT RESULT DATA of the PATIENT // ---------------------------------------------------------------------------------------------
// clearing redux state when unmounting patient profile page
export const clearKitsResultsData = (history) => {
  return {
    type: KITS_RESULTS_CLEAR_DATA,
    payload: { history },
  };
};

//* CLEAR KITS RESULTS TIMECOURSE DATA of the PATIENT // ---------------------------------------------------------------------------------------------
// clearing redux state when unmounting patient profile page
export const clearKitsResultsTimecourseData = (history) => {
  return {
    type: KITS_RESULTS_TIMECOURSE_CLEAR_DATA,
    payload: { history },
  };
};
